import { z } from 'zod';

const navigationSchema = z.object({
  entityType: z.enum(['workOrder', 'person', 'company', 'vehicle']),
  entityId: z.string().uuid(),
});

const ROUTES = {
  workOrder: '/workorders',
  person: '/parties/persons',
  company: '/parties/companies',
  vehicle: '/vehicles',
} as const;

/** A server command names a supported record, never an arbitrary URL. */
export function assistantNavigationHref(value: unknown): string | undefined {
  const parsed = navigationSchema.safeParse(value);
  return parsed.success ? `${ROUTES[parsed.data.entityType]}/${parsed.data.entityId}` : undefined;
}
